import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import * as Cookie from 'js-cookie';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isPWA } from '../utils/isPWA';
import { URLS } from '@wix/da-url';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { savePWAInstallPrompt } from '../redux/pwa/actions';
import { useSelector } from 'react-redux';
import { getPWAInstallPrompt } from '../redux/pwa/selectors';
export const COOKIE_NAME = 'pwai';
export function usePWAInstallBanner() {
    const { isLoggedIn } = useContext(SessionContext);
    const dispatchSaveInstallPrompt = useAction(savePWAInstallPrompt);
    const installPrompt = useSelector(getPWAInstallPrompt);
    const isMobile = useContext(MobileContext);
    const cookieValue = Cookie.get(COOKIE_NAME);
    const [isDismissed, setIsDismissed] = useState(true);
    const isStandalone = useMemo(()=>isPWA(), []);
    const isHidden = !isLoggedIn || !isMobile || isStandalone || isDismissed;
    // dismiss banner for 30 days
    const dismiss = useCallback(()=>{
        Cookie.set(COOKIE_NAME, '1', {
            expires: 30
        });
        setIsDismissed(true);
    }, []);
    useEffect(()=>{
        if (cookieValue !== '1') {
            setIsDismissed(false);
        }
        const ready = (e)=>{
            e.preventDefault();
            dispatchSaveInstallPrompt(e);
        };
        window.addEventListener('beforeinstallprompt', ready);
        return ()=>{
            window.removeEventListener('beforeinstallprompt', ready);
        };
    }, [
        isHidden,
        cookieValue,
        dispatchSaveInstallPrompt
    ]);
    const handleInstall = async ()=>{
        installPrompt && installPrompt.prompt();
        // user has PWA installed, let's try to open it.
        if (!installPrompt) {
            window.location.assign(URLS.ROOT);
        }
    };
    return {
        isHidden,
        dismiss,
        installPrompt,
        onInstall: handleInstall
    };
}

//# sourceMappingURL=usePWAInstallBanner.js.map